export default __webpack_public_path__ + "static/media/media-residential-2.4a291bf4.jpg";